import PropTypes from 'prop-types';
import React from 'react';

import { ACCOUNT_CREATED_SUCCESS } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';

const AccountCreatedSuccessModal = ({ nickname }) => {
  return (
    <ReactModal
      size="small"
      className="modal-welcome"
      title={trans('userspace.sign-up.success-modal.title', { nickname })}
    >
      <p>{trans('userspace.sign-up.success-modal.text')}</p>
      <button
        type="button"
        className="button button-inverse-full js-trigger-overlay-close"
      >
        {trans('userspace.account-action.success.button-text')}
      </button>
    </ReactModal>
  );
};

AccountCreatedSuccessModal.propTypes = {
  nickname: PropTypes.string.isRequired
};

export default buildReactDomModalModule(
  ACCOUNT_CREATED_SUCCESS,
  (params = {}) => <AccountCreatedSuccessModal nickname={params.nickname} />
);
